export const data = [
  {
    faq: "When will REVA HACK 2022 take place?",
    ans: "REVA HACK 2022 is scheduled for 11th-13th of November over 48 hours accompanied by various pre-events like learnathons, workshops, etc.",
  },
  {
    faq: "Is it a remote or an on-site Hackathon?",
    ans: "This time REVA HACK goes the best of both worlds, it's a Hybrid Hackathon. Hackers can join us either virtually or physically (on campus), whatever suits them the best.",
  },
  {
    faq: "What is Learnathon? What happens at a Learnathon?",
    ans: "Learnathon is a pre-event talk and workshop session dedicated to increasing the awareness of hackathons and similar tech events among the attendees. The event aims to ignite the spirit of hackathons among students.",
  },
  {
    faq: "Are there any specific programming languages or domains discussed in Learnathon?",
    ans: "Learnathon is a mix of various tech demonstrations and workshops not particularly focused on a single domain/language. The exact schedule of the vent is to be released soon.",
  },
  {
    faq: "Does REVA HACK 2022 have any restrictions on the programming language to be used?",
    ans: "Nope, you are free to use whatever tech stalk/programming language you please. From Haskell to Holy C, whatever sails your boat.",
  },
  {
    faq: "Who can apply for REVA HACK 2022?",
    ans: "Students & working professionals from all disciplines are welcome to apply for the event.",
  },
  {
    faq: "Are meals and accommodation provided at the venue?",
    ans: "If approved to attend the event on-site, the participants will be provided food and accommodation for the duration of the event.",
  },
  {
    faq: "What kind of skill set is required for REVA HACK 2022?",
    ans: "There is no such skill required as a prerequisite for the hackathon. Although we do hope to see the skill of innovation among the participants.",
  },
  {
    faq: "How does one avail accommodation facilities?",
    ans: "Only approved participants will be provided accommodation on-site during the event. The details of accommodation will be informed to the participants after all the paperwork is verified at the venue.",
  },
  {
    faq: "Will I miss out on anything if I join the event virtually?",
    ans: "REVA HACK 2022 maintains a level playing ground for Virtual and in-person attendees. But engagement events and stress busters will mostly be available only to the in-person attendees.",
  },
  {
    faq: "What do I pay to register for the event?",
    ans: "0, Nill, Nought, Cero, Nada. REVA HACK 2022 will be a free-to-attend event for all participants.",
  },
  {
    faq: "How do I submit my project for the Hackathon?",
    ans: "We will take submissions through the Devfolio portal in accordance with their code of conduct. Further details on the submission and evaluation phases will be e-mailed to the participants.",
  },
  {
    faq: "Do you need to have your project fully functional for submission?",
    ans: "You can always submit your project at whatever stage you want but the progress made during the hackathon is a key criterion for evaluation.",
  },
  {
    faq: "Will you provide any computers or Software to work with?",
    ans: "We prefer participants to carry their computers and tools for the event. If required, arrangements for computer facilities can be made on the campus. As for software tool availability, that'll be posted shortly.",
  },
  {
    faq: "Does one have to be present online for the entire duration of the event?",
    ans: "The participants have to be reachable for the entire duration of the event. Progress evaluation and elevator pitch events will be held at fixed durations throughout the hackathon, they will also be considered for the final grading. The schedule for the same will be available shortly.",
  },
  {
    faq: "Are there any restrictions on the use of pre-built libraries and packages?",
    ans: "Technically no, you can use as many packages, libraries, and, modules as you want. But your contribution to your project will outweigh everything else during the final evaluation.",
  },
  {
    faq: "Who will own the IP ( Intellectual Property) of the projects made during REVA HACK 2022?",
    ans: "In short YOU. Every project submitted during REVA HACK 2022 needs to come from an Open Source repo that's publicly accessible. The organizers of the event in no manner or form shall have any stake in the projects made during the event.",
  },
  {
    faq: "Do I need to demo my project during the event?",
    ans: "You will be required to demonstrate your project and share your work progress several times during the event. These demonstrations will be considered for grading and Evaluation.",
  },
  {
    faq: "Is it ok to just show a prototype of my project?",
    ans: "You can always submit a working prototype of your idea. It'll be evaluated based on progress made on the project during the event.",
  },
  {
    faq: "Are you sure I won't get bored or lose motivation?",
    ans: "We've got you covered fam, we have many events lined up just to keep you engaged and invested in the event. From icebreakers to stress Busters, bored says goodbye at REVA HACK",
  },
];
